import { render, staticRenderFns } from "./resourcePathList.vue?vue&type=template&id=2d0aae3a&scoped=true&"
import script from "./resourcePathList.vue?vue&type=script&lang=js&"
export * from "./resourcePathList.vue?vue&type=script&lang=js&"
import style0 from "./resourcePathList.vue?vue&type=style&index=0&id=2d0aae3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0aae3a",
  null
  
)

export default component.exports